import './add-filter-button';
import './edit-dialog';
import './quick-actions/delete';
import './quick-actions/edit';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss';

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.itemLoop;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-loop-filter' )
export class AutomatorBuilderItemLoopFilter extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The unique ID of the loop (parent of this loop filter)
	@property( { type: Number, attribute: 'loop-id' } ) accessor loopID;

	// The unique ID of this loop filter
	@property( { type: Number, attribute: 'loop-filter-id' } ) accessor id;

	// The code of the loop filter
	@property( { type: String, attribute: 'loop-filter-code' } ) accessor code;

	// The code of the integration
	@property( { type: String, attribute: 'integration-code' } ) accessor integrationCode;

	// The loop fields
	@property( { type: Array, attribute: false } ) accessor fields = [];

	// The backup data, to be used when the directory data is not available
	@property( { type: Array, attribute: false } ) accessor backup = [];

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="filter-item">
				${ this._templateIntegrationIcon }
				${ this._templateSentence }
				${ this._templateActions }
			</div>
		`;
	}

	/**
	 * Renders the integration icon
	 *
	 * @return {TemplateResult} The integration icon
	 */
	get _templateIntegrationIcon() {
		return html`
			<div class="filter-item-icon">
				<uo-icon integration="${ this.integrationCode }" show-tooltip></uo-icon>
			</div>
		`;
	}

	/**
	 * Renders the sentence of the filter
	 *
	 * @return {TemplateResult} The filter sentence
	 */
	get _templateSentence() {
		return html`
			<uap-builder-item-sentence
				item-id=${ this.id }
				.sentence=${ this.directoryItemData.sentence_readable }
				.fields=${ this.fields }

				not-interactive-pills
			></uap-builder-item-sentence>
		`;
	}

	/**
	 * Renders the actions of the filter (e.g. delete button)
	 *
	 * @return {TemplateResult} The actions
	 */
	get _templateActions() {
		return html`
			<div class="filter-item-buttons">
				<uap-builder-item-loop-filter-btn-edit
					loop-id=${ this.loopID }
					loop-filter-id=${ this.id }
					loop-filter-code=${ this.code }
					integration-code=${ this.integrationCode }
					.fields=${ this.fields }
				></uap-builder-item-loop-filter-btn-edit>

				<uap-builder-item-loop-filter-btn-delete
					loop-id=${ this.loopID }
					loop-filter-id=${ this.id }
				></uap-builder-item-loop-filter-btn-delete>
			</div>
		`;
	}

	/**
	 * Returns the global/directory data of this item
	 *
	 * @return {Object} The directory data of this item. This contains, for example, the fields attributes
	 */
	get directoryItemData() {
		return UncannyAutomator._core.directory.items.getLoopFilter(
			this.integrationCode,
			this.code
		);
	}
}